<template>
  <div>
    <el-card class="box-card box-cards" shadow="never">
      <el-row>
        <el-form :inline="true" class="user-search">
          <el-col :span="24">
            <el-form-item>
              <div class="card_top"><span>消息列表</span></div>
            </el-form-item>

            <el-form-item>
              <el-button size="small" type="primary" plain @click="handleEdit()">添加
              </el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
    </el-card>
    <el-card class="box-card box-cards2" shadow="never">
      <!--列表-->
      <el-table border ref="multipleTable" :data="tableData" :header-cell-style="headStyle" tooltip-effect="dark"
        style="width: 100%; " v-loading="loading">
        <el-table-column align="center" type="index" label="序号" width="80"></el-table-column>
        <el-table-column prop="id" label="主键id" align="center" width="140"></el-table-column>

        <el-table-column prop="title" label="通知标题" align="center"></el-table-column>

        <el-table-column prop="jtime" label="通知时间" align="center">
          <template slot-scope="scope">
            <div>{{ scope.row.createTime | timestampToTime }}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="100">
          <template slot-scope="scope">

            <el-button size="mini" @click="chankan(scope.row)">查看 </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </el-card>

    <el-drawer :title="title" :visible.sync="editFormVisible" :before-close="handleClose" direction="rtl"
      custom-class="demo-drawer" ref="drawer" size="30%">
      <div class="demo-drawer__content">
        <el-row>
          <el-form label-width="110px" :model="editForm" :rules="rules" ref="editForm">
            <el-col :span="22">
              <div class="grid-content bg-purple">
                <el-form-item label="消息名称" prop="name">
                  <el-input v-model="editForm.params.title" placeholder="请输入消息名称"></el-input>
                </el-form-item>
                <el-form-item label="消息内容：" prop="telephone">
                  <vue-editor v-model="editForm.params.content" useCustomImageHandler placeholder="请输入内容"
                    maxlength="1500" autosize type="textarea" @image-added="savePicHandle"
                    @image-removed="removedPicHandle" />

                </el-form-item>
              </div>
            </el-col>

          </el-form>
        </el-row>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="handleClose">取消</el-button>
          <el-button size="small" type="goon" class="title" @click="submitForm('editForm')">
            保存</el-button>
        </div>
        <div style="height: 60px; margin-top: 50px"></div>
      </div>
    </el-drawer>


    <el-drawer title="消息内容" :visible.sync="editFormVisible1" :before-close="handleClose" direction="rtl"
      custom-class="demo-drawer" ref="drawer" size="30%">
      <div class="" style="padding: 0 10px;">
        <div v-html="content"></div>

        <div style="height: 60px; margin-top: 50px"></div>
      </div>
    </el-drawer>

  </div>
</template>
<script>
import axios from 'axios';
import { VueEditor } from "vue2-editor";
import Pagination from "../../components/Pagination";
import debounce from "../../utils/debounce";
import { messageslist, messages } from "../../api/userMG";
export default {
  data() {
    return {
      title: "编辑信息",
      //分页
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      rules: [],
      editFormVisible: false,
      editFormVisible1: false,
      content: "",
      tableData: [], //表格数据
      formInline: {
        data: {},
        params: {
          pageNum: 1,
          pageSize: 10
        },
      },
      editForm: {
        data: {},
        params: {
          "id": 0,
          "title": "",
          "content": "",
          "type": 1
        },
      }

    };
  },
  components: {
    Pagination,
    VueEditor
  },
  created() {
    //数据列表
    this.getlist(this.formInline);
  },
  methods: {
    headStyle() {
      return {
        background: "#A1BBFF",
        color: "#fff",
        letterSpacing: "2px",
        border: " 1px solid #A1BBFF",
        textAlign: "center",
        height: "39px",
      };
    },
    //显示数据
    getlist(parameter) {
      this.loading = true;
      messageslist(parameter)
        .then((res) => {
          this.loading = false;
          if (res.code != 200) {
            this.$message({
              type: "info",
              message: res.message,
            });
          } else {
            this.tableData = res.data.records;
            // 分页赋值
            this.pageparm.currentPage = this.formInline.params.pageNum;
            this.pageparm.pageSize = this.formInline.params.pageSize;
            this.pageparm.total = res.data.total;
            // console.log(this.tableData)
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("加载失败，请稍后再试！");
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.params.pageNum = parm.currentPage;
      this.formInline.params.pageSize = parm.pageSize;
      this.getlist(this.formInline);
    },
    // 搜索事件
    search() {
      this.formInline.params.pageNum = 1;
      this.getlist(this.formInline); //显示
    },
    //关闭弹框
    handleClose(done) {
      this.editFormVisible = false
      this.editFormVisible1 = false

    },

    //添加，修改
    handleEdit(index, row) {
      this.editFormVisible = true;

      this.editForm = {
        data: {},
        params: {
          "title": "",
          "content": "",
          "type": 1
        },
      }


    },
    chankan(row) {
      this.content = row.content;
      this.editFormVisible1 = true;
    },
    //提交添加，修改
    submitForm(info) {

      debounce(() => {
        messages(this.editForm)
          .then(res => {
            if (res.code == 200) {
              this.editFormVisible = false;
              this.getlist(this.formInline);
              this.$message({
                message: "保存成功！",
                type: "success",
              });
            } else {
              this.$message({
                type: "info",
                message: res.message,
              });
            }
          })
          .catch((err) => {
            this.editFormVisible = false;
            this.loading2 = false;
            this.$message.error("保存失败，请稍后再试！");
          });

      }, 1500);
    },

    // 保存图片实现方法
    savePicHandle(file, Editor, cursorLocation, resetUploader) {
      // console.log('2222222222222222222222222', file, Editor, cursorLocation)
      // 引入包内自带的formdata
      const formData = new FormData();
      // 将前端传入formdata中数据名为file的数据追加到formdata,与上篇文章的图片上传相同
      formData.append("files", file);
      // 使用我们上篇文章定义好的图片上传接口,将formdata数据传到后台,并接收返回的数据到res
      // const file = event.target.files[0];
      // const formData = new FormData();
      // formData.append('image', file);

      axios.post(this.imagesrc, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(response => {
          // 处理响应
          //console.log(response.data.data);
          let url = response.data.data[0].url;
          Editor.insertEmbed(cursorLocation, "image", url);
          // 刷新(重置)编辑器
          resetUploader();

        })
        .catch(error => {
          // 处理错误
          console.error(error);
        });
    },
    removedPicHandle(image) {
      console.log(image)
    },

  },
};
</script>
<style>
@import "../../assets/css/index.css";

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.divBox {
  /*flex-direction: row;*/
  float: left;
  position: relative;
  margin-right: 10px;
}

.imgSty {
  margin-left: 3px;
}

.delIcon {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 20px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 145px;
  height: 145px;
  line-height: 145px;
  text-align: center;
}

.avatar {
  width: 145px;
  height: 145px;
  display: block;
}
</style>


// WEBPACK FOOTER //
// src/views/system/messages.vue